var products = [{
            Men: [
                {
                    product: "Triathlon",
                    name: "Prana Core Men's Eco Triathlon Wetsuit Limited Edition",
                    price: 1199.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5,
                    buoyancy: 5,
                    speed: 5,
                    thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Prana_Core_men_101396be-01f8-4a6a-a6f7-e87367534951.png?v=1741141387",
                    product_url: 'https://www.sumarpo.com/products/mens-victory-eco-wetsuit',
                    property: "Performance"
                },
                {
                    product: "Triathlon",
                    name: "Victory Men's Eco Triathlon Wetsuit",
                    price: 779.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Even Buoyancy',
                                    title: 'Even',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#45',
                                    title: 'Best',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Victory_Man_31529018-afba-4516-8f6d-428fb6b96946.png?v=1741141385",
                    product_url: 'https://www.sumarpo.com/products/mens-victory-Eco-Wetsuit',
                    property: "Performance,ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Elite Pro Men's Eco Triathlon Wetsuit",
                    price: 649.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Leg Buoyancy',
                                    title: 'Leg',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#40',
                                    title: 'Better',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Elite_Pro_Men_8d72706f-3c86-40f6-84ec-b837620dba4b.png?v=1741141387",
                    product_url: 'https://www.sumarpo.com/products/elite-pro-mens-eco-triathlon-wetsuit',
                    property: "Performance,Buoyancy"
                }, {
                    product: "Triathlon",
                    name: "Vanguard Men's Eco Triathlon Wetsuit",
                    price: 559.99,
                     optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 5,
                    product_url: 'https://www.sumarpo.com/products/mens-vanguard-ll-Wetsuit',
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Vanguard_Man_0f94452e-f88e-4b0a-92c3-9c864e3a94c5.png?v=1741141387",
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Men's Eco Sleeveless Triathlon Wetsuit",
                    price: 449.99,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3.5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Vanguard_Sleeveless_Man_d8301211-cbe5-45a9-be1b-b1aee6ce8543.png?v=1741141385",
                    product_url: 'https://www.sumarpo.com/products/mens-vanguard-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Race Men's Eco Triathlon Wetsuit",
                    price: 439.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Race_Man_46125cb8-813a-4ff7-b6fc-e2988a21ddcf.png?v=1741141386",
                    product_url: 'https://www.sumarpo.com/products/mens-race-ll-Wetsuit',
                    property: "Buoyancy,Speed"
                },
                {
                    product: "Triathlon",
                    name: "Nova Men's Eco Triathlon Wetsuit",
                    price: 369.99,
                   optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                              
                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                              {
                                icon: 'Buoyancy',
                                title: 'More',
                                content: 'Buoyancy'
                            },{
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4, thermal: 4.5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Nova_Man_82e979d5-85de-41f1-9913-2036d1dbf86e.png?v=1741141384",
                    product_url: 'https://www.sumarpo.com/products/nova-mens-eco-triathlon-wetsuit',
                    property: "Buoyancy,BodyStretch"
                },
                {
                    product: "Triathlon",
                    name: "Nova Men's Eco Sleeveless Triathlon Wetsuit",
                    price: 319.99,
                      optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Nova_Sleeveless_Man_3b268cdc-bb39-4d68-9a39-5c098f999987.png?v=1741141384",
                    product_url: 'https://www.sumarpo.com/products/mens-nova-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "N-Joy Men's Eco Triathlon Wetsuit",
                    price: 244.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                             
                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                                {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/N-Joy_Man_4a78417d-13c9-4fe2-8d7c-7a3fdd4f5b9e.png?v=1741141386",
                    product_url: 'https://www.sumarpo.com/products/mens-n-joy-ll-Wetsuit',
                    property: "BodyStretch"
                },
                {
                    product: "Swimrun",
                    name: "Current Men's Eco Swimrun Wetsuit",
                    price: 599.99,
                    flexibility: 5, buoyancy: 5,
                    speed: 5, thermal: 5,
                    describe: "The ultimate Swimrun Wetsuit for cold weather",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Current_Man_7a130b82-6013-407c-a660-f2f89cfe0ab0.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/mens-current-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "X-Ray Men's Eco Swimrun Wetsuit",
                    price: 539.99,
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    describe: "Great all-around Swimrun Wetsuit with style",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/X-ray_Man_60b1bd5a-5c87-4e81-99e1-d411e2015181.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/mens-x-ray-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Innovator Men's Eco Swimrun Wetsuit",
                    price: 467.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 4.5,
                    describe: "Very comfortable during both swim and run",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Innovator_Man_7943925a-bb21-445e-921e-386cc9e3c95d.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/mens-innovator-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Pro Men's Eco Swimrun Wetsuit",
                    price: 495.99,
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 4,
                    describe: "The most advanced Swimrun wetsuit in our line up",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Pro_Man_98ce5bfb-008b-424b-ab3b-8d6ff9e614b5.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/mens-Hyper-pro-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Fast Men's Eco Swimrun Wetsuit",
                    price: 334.99,
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3,
                    describe: "The ultimate hot weather Swimrun Wetsuit. Best for elite swimmers",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Fast_Man_82367580-e92e-4a75-9a18-6bb08cf96fe2.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/mens-Hyper-fast-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Light Men's Eco Swimrun Wetsuit",
                    price: 299.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 3.5,
                    describe: "A good all-arounder for beginners",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Light_Man_b30fe893-1383-442b-974f-c7f94cceb9b5.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/mens-Hyper-light-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire-Pro Men's Open Water Swimming Wetsuit",
                    price: 419.99,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "Help intermediate swimmers to gain a lot of speed",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Aspire_Pro_Man_7013aec0-0919-4bb1-aea8-9346a8a11b18.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/aspire-pro-mens-open-water-swimming-Wetsuit",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire Men's Open Water Swimming Wetsuit",
                    price: 239.99,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 3.5, thermal: 4,
                    describe: "Great for beginners to test out open water",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Aspire_Man_3bf5eae7-d5ee-4e43-9e6d-3b16ff3138bb.png?v=1741141384",
                    product_url: "https://www.sumarpo.com/products/aspire-mens-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Nova Men's Eco Sleeveless Open Water Swimming Wetsuit",
                    price: 319.99,
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    describe: "For more comfortable swims in the summer",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Nova_Sleeveless_Man_3b268cdc-bb39-4d68-9a39-5c098f999987.png?v=1741141384",
                    product_url: "https://www.sumarpo.com/products/mens-nova-sleeveless-Eco-open-water-swimming-Wetsuit-Preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "N-Joy Men's Eco Open Water Swimming Wetsuit",
                    price: 244.99,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    describe: "Easily fit every body type",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/N-Joy_Man_4a78417d-13c9-4fe2-8d7c-7a3fdd4f5b9e.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/mens-n-joy-Eco-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                }
            ],
            Women: [
                {
                    product: "Triathlon",
                    name: "Prana Core Women's Eco Triathlon Wetsuit",
                    price: 1199.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                icon: 'Fish Scale',
                                title: 'Next-gen',
                                content: 'Bio-Skin'
                            }, {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                                
                            }, {
                               icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                               
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Prana_Core_Women_f58b58cb-4ffc-4707-859c-f841f7829e5d.png?v=1741141388",
                    product_url: 'https://www.sumarpo.com/products/prana-core-womens-eco-triathlon-wetsuit',
                    property: "Performance"
                },
                {
                    product: "Triathlon",
                    name: "Victory Women's Eco Triathlon Wetsuit",
                    price: 779.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#45',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [

                            ], ShoulderFlexibility: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Even Buoyancy',
                                    title: 'Even',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#45',
                                    title: 'Best',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Victory_Woman_ceb0b3b9-db0b-40d8-a5c4-aec81357c29d.png?v=1741141386",
                    product_url: 'https://www.sumarpo.com/products/womens-victory-Eco-Wetsuit-1',
                    property: "Performance,ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Elite Pro Women's Eco Triathlon Wetsuit",
                    price: 649.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                                {
                                    icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'NANO SCS',
                                title: 'Fastest',
                                content: 'Hydrodynamic Coating'
                                }
                            ], Speed: [

                            ], Buoyancy: [
                                {
                                    icon: 'Buoyancy',
                                    title: 'More',
                                    content: 'Buoyancy'
                                }, {
                                    icon: 'Leg Buoyancy',
                                    title: 'Leg',
                                    content: 'Buoyancy'
                                }, {
                                    icon: '#40',
                                    title: 'Better',
                                    content: 'Shoulder Flexibility'
                                }, {
                                    icon: 'NANO SCS',
                                    title: 'Fastest',
                                    content: 'Hydrodynamic Coating'
                                }
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Elite_Pro_Women_a1c2d433-57a3-47ec-b65f-8b6fc5ab8c9d.png?v=1741141387",
                    product_url: 'https://www.sumarpo.com/products/elite-pro-womens-eco-triathlon-wetsuit',
                    property: "Performance,Buoyancy"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Women's Eco Triathlon Wetsuit",
                    price: 559.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Torso Buoyancy',
                                title: 'Torso',
                                content: 'Buoyancy'
                            }, {
                                icon: '#40',
                                title: 'Great',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4.5, thermal: 5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Vanguard_Woman_08e7684d-7812-4590-96f7-a86d42f4af85.png?v=1741141387",
                    product_url: 'https://www.sumarpo.com/products/women-vanguard-Eco-Wetsuit',
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Vanguard Women's Eco Sleeveless Triathlon Wetsuit",
                    price: 449.99,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3.5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Vanguard_Sleeveless_Woman_c15a531b-2d68-4f22-805f-166159017deb.png?v=1741141385",
                    product_url: 'https://www.sumarpo.com/products/womens-vanguard-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "Race Women's Eco Triathlon Wetsuit",
                    price: 439.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Race_Woman_50946307-1fdf-4015-a645-dbd646f62ba0.png?v=1741141386",
                    product_url: 'https://www.sumarpo.com/products/womens-race-ll-Wetsuit',
                    property: "Speed"
                },
                {
                    product: "Triathlon",
                    name: "Nova Women's Eco Triathlon Wetsuit",
                    price: 369.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                              
                            ], Buoyancy: [
                              {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                              {
                                icon: 'Buoyancy',
                                title: 'More',
                                content: 'Buoyancy'
                            },{
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 4,
                    speed: 4, thermal: 4.5,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Nova_Woman_665b97b1-a833-4067-8f87-32773f06ace6.png?v=1741141384",
                    product_url: 'https://www.sumarpo.com/products/nova-womens-eco-triathlon-wetsuit',
                    property: "Buoyancy,BodyStretch"
                },
                {
                    product: "Triathlon",
                    name: "Nova Women's Eco Sleeveless Triathlon Wetsuit",
                    price: 319.99,
                    optionData: {
                        Price: [
                           
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [

                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [
                               {
                                icon: 'Leg Buoyancy',
                                title: 'Leg',
                                content: 'Buoyancy'
                            }, {
                                icon: 'Sleeveless',
                                title: 'Best',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ], BodyStretch: [

                            ]
                        }
                    },
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Nova_Sleeveless_Woman_30efc9f7-1119-426d-82a8-c7d9702e33d4.png?v=1741141383",
                    product_url: 'https://www.sumarpo.com/products/womens-nova-sleeveless-Wetsuit',
                    property: "ShoulderFlexibility"
                },
                {
                    product: "Triathlon",
                    name: "N-Joy Women's Eco Triathlon Wetsuit",
                    price: 244.99,
                    optionData: {
                        Price: [
                            {//编写价格的默认动态图片数据
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                            }, 
                        ],
                        Performance: {
                            Performance: [
                    
                            ], Speed: [
                             
                            ], Buoyancy: [
                               
                            ], ShoulderFlexibility: [

                            ], BodyStretch: [
                                {
                                icon: 'Even Buoyancy',
                                title: 'Even',
                                content: 'Buoyancy'
                            }, {
                                icon: '#39',
                                title: 'Good',
                                content: 'Shoulder Flexibility'
                            }, {
                                icon: 'SCS',
                                title: 'Partial Faster',
                                content: 'Hydrodynamic Coating'
                                }

                            ]
                        }
                    },
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/N-joy_Woman_b15c8752-602b-4ecc-b237-de420ef43cd9.png?v=1741141387",
                    product_url: 'https://www.sumarpo.com/products/womens-n-joy-ll-Wetsuit',
                    property: "BodyStretch"
                },
                {
                    product: "Swimrun",
                    name: "Current Women's Eco Swimrun Wetsuit",
                    price: 599.99,
                    flexibility: 5, buoyancy: 5,
                    speed: 5, thermal: 5,
                    describe: "The ultimate Swimrun Wetsuit for cold weather",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Current_Woman_c8c6c597-acbf-494c-b1c3-3ad6a65b8ece.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/womens-current-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "X-Ray Women's Eco Swimrun Wetsuit",
                    price: 539.99,
                    flexibility: 4.5, buoyancy: 5,
                    speed: 4.5, thermal: 5,
                    describe: "Great all-around Swimrun Wetsuit with style",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/X-Ray_Woman_9479a04c-3017-47e8-8fc5-ddc6035c11f1.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/womens-x-ray-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Innovator Women's Eco Swimrun Wetsuit",
                    price: 467.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 4.5,
                    describe: "Very comfortable during both swim and run",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Innovator_Woman_c45aea8e-7f36-499e-8c95-a65c52eafe10.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/womens-innovator-Eco-Swimrun",
                    ProductOptions: "Cooler(Long Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Pro Women's Eco Swimrun Wetsuit",
                    price: 495.99,
                    flexibility: 5, buoyancy: 4.5,
                    speed: 5, thermal: 4,
                    describe: "The most advanced Swimrun wetsuit in our line up",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Pro_Woman_d11146ca-6276-4a36-9dd3-5d7100246a37.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/womens-Hyper-pro-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Fast Women's Eco Swimrun Wetsuit",
                    price: 334.99,
                    flexibility: 5, buoyancy: 4,
                    speed: 4, thermal: 3,
                    describe: "The ultimate hot weather Swimrun Wetsuit. Best for elite swimmers.",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Fast_Woman_cdb89b1e-e137-4891-8d6a-396070c7519b.png?v=1741141386",
                    product_url: "https://www.sumarpo.com/products/womens-Hyper-fast-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "Swimrun",
                    name: "Hyper Light Women's Eco Swimrun Wetsuit",
                    price: 299.99,
                    flexibility: 4.5, buoyancy: 4.5,
                    speed: 4, thermal: 3.5,
                    describe: "A good all-arounder for beginners",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Hyper_Light_Woman_dc755c4e-a08f-4e82-90c7-925bbfd4fcfc.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/womens-Hyper-light-Eco-Swimrun",
                    ProductOptions: "Warmer(Short Sleeves)"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire-Pro Women's Open Water Swimming Wetsuit",
                    price: 419.99,
                    flexibility: 4, buoyancy: 4,
                    speed: 4.5, thermal: 4.5,
                    describe: "Help intermediate swimmers to gain a lot of speed",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Aspire_Pro_Woman_0af23723-ab7b-42ba-b9e5-f0361baf1879.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/aspire-pro-womens-open-water-swimming-Wetsuit",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Aspire Women's Open Water Swimming Wetsuit",
                    price: 239.99,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 3.5, thermal: 4,
                    describe: "Great for beginners to test out open water",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Aspire_Woman_bed670cf-0a27-400c-b480-76b3fc46b996.png?v=1741141385",
                    product_url: "https://www.sumarpo.com/products/aspire-womens-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "Nova Women's Eco Sleeveless Open Water Swimming Wetsuit",
                    price: 319.99,
                    flexibility: 5, buoyancy: 3.5,
                    speed: 3.5, thermal: 3,
                    describe: "For more comfortable swims in the summer",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/Nova_Sleeveless_Woman_30efc9f7-1119-426d-82a8-c7d9702e33d4.png?v=1741141383",
                    product_url: "https://www.sumarpo.com/products/womens-nova-sleeveless-Eco-open-water-swimming-Wetsuit-Preorder",
                    ProductOptions: "Higher"
                },
                {
                    product: "OpenWaterSwimming",
                    name: "N-Joy Women's Eco Open Water Swimming Wetsuit",
                    price: 244.99,
                    flexibility: 4, buoyancy: 3.5,
                    speed: 4, thermal: 4,
                    describe: "Easily fit every body type",
                    image_url: "https://cdn.shopify.com/s/files/1/0523/5048/4641/files/N-joy_Woman_b15c8752-602b-4ecc-b237-de420ef43cd9.png?v=1741141387",
                    product_url: "https://www.sumarpo.com/products/womens-n-joy-Eco-open-water-swimming-Wetsuit",
                    ProductOptions: "Lower"
                }
            ]
        }]
